import { db, storage, functions } from '@/firebase'
export default {
  saveDatosGenerales({ rootState, rootGetters }, datos) {

    const dominios = datos.dominios;
    delete datos.dominios
    var ref;
    if (rootGetters['app/esNegocio']) {
      const negocio = rootState.app.negocioGest;
      ref = db.collection('negocios').doc(negocio)
    } else if (rootGetters['app/esDirectorio']) {
      const directorio = rootState.app.directorioGest;
      ref = db.collection('directorios').doc(directorio)
    }
    return ref.set({
      dominios: dominios,
      web: datos
    }, { merge: true })
  },
  subirImagen({ rootState }, payload) {
    const negocio = rootState.app.negocioGest;
    var storageRef = storage.ref();
    var ref = payload.child
      ? storageRef.child(payload.child + payload.imagen.name)
      : storageRef.child('webPropio/' + negocio + '/' + payload.imagen.name);
    return ref.put(payload.imagen)
      .then((r) => {
        return r.ref.getDownloadURL();
      })
      .then((r) => {
        const url = r;
        return url;
      })
  },
  subirImagenRest({ rootState }, payload) {
    const negocio = rootState.app.negocioGest;
    const rest = payload.restaurante;
    var storageRef = storage.ref();
    var ref = storageRef.child('webPropio/' + negocio + '/' + rest + '/' + payload.imagen.name);
    return ref.put(payload.imagen)
      .then((r) => {
        return r.ref.getDownloadURL();
      })
      .then((r) => {
        const url = r;
        return url;
      })
  },
  async generarSitemap({ rootState }, { idiomas, dinamicas }) {
    const negocio = rootState.app.negocioGest;
    const negocioObj = rootState.app.negocioObjGest;
    const host = negocioObj.dominios[0];
    const protocol = "https";
    var restaurantes = (await db.collection('restaurantes').where('negocio', '==', negocio).get()).docs.map(r => r.id)
    console.log(restaurantes)

    let res = idiomas.map(i => {
      let prefijo = i == 'es' ? '' : "/" + i;
      // var sitemap = prefijo;
      var sitemap = prefijo + "/\n";
      sitemap += prefijo + "/domicilio\n";
      sitemap += prefijo + "/recoger\n";
      sitemap += prefijo + "/finalizar\n";
      sitemap += prefijo + "/tu-cuenta/formas-pago\n";
      sitemap += prefijo + "/tu-cuenta/perfil\n";
      sitemap += prefijo + "/resumen-pedido\n";
      sitemap += prefijo + "/politica-de-cookies\n";
      sitemap += prefijo + "/terminos-y-condiciones\n";
      sitemap += prefijo + "/encuentranos\n";
      dinamicas.forEach(d => {
        sitemap += prefijo + d.path + "\n"
      })
      restaurantes.forEach(r => {
        sitemap += prefijo + "/pedir/domicilio/" + r + "\n";
        sitemap += prefijo + "/pedir/recoger/" + r + "\n";
        sitemap += prefijo + "/carta/" + r + "\n";
      })
      return sitemap;
    }).join("")
    console.log(res);
    return res;
    var sitemap = "";
    sitemap += "/\n";
    sitemap += "/domicilio\n";
    sitemap += "/recoger\n";
    sitemap += "/finalizar\n";
    sitemap += "/tu-cuenta/formas-pago\n";
    sitemap += "/tu-cuenta/perfil\n";
    sitemap += "/resumen-pedido\n";
    sitemap += "/politica-de-cookies\n";
    sitemap += "/terminos-y-condiciones\n";
    dinamicas.forEach(d => {
      sitemap += d.path + "\n"
    })
    return db.collection('restaurantes').where('negocio', '==', negocio).get()
      .then(snap => {
        snap.forEach(r => {
          sitemap += "/pedir/domicilio/" + r.id + "\n";
          sitemap += "/pedir/recoger/" + r.id + "\n";
        });
        return sitemap;
      })
  },
  generarManifest({ rootState }, payload) {
    const id = rootState.app.negocioGest;
    var m = functions.httpsCallable('httpPropioGenerarManifest')
    return m(payload)
    // .then(() => {
    //   var ref = storage.ref('webPropio/' + id + '/pwa/manifest.json');
    //   return ref.getDownloadURL();
    // })
    // .then((url) => {
    //   return db.collection('negocios').doc(id).update({
    //     "pwaGenerado.manifest": url
    //   })
    // })

  },
  generarComponente({ rootState }, payload) {
    const negocio = rootState.app.negocioGest;
    payload.negocio = negocio;
    var m = functions.httpsCallable('httpPropioGenerarComponenteDinamico')
    return m(payload)
      .then((r) => { console.log(r) })
  },
  saveRedirecciones({ rootState, rootGetters }, payload) {
    var ref;
    var id;
    console.log(payload);
    if (rootGetters['app/esNegocio']) {
      id = rootState.app.negocioGest;
      ref = db.collection('negocios').doc(id)
    } else if (rootGetters['app/esDirectorio']) {
      id = rootState.app.directorioGest;
      ref = db.collection('directorios').doc(id)
    }
    return ref.update({
      "web.redirecciones": payload
    })
  },
  savePaginaDinamica({ rootState, rootGetters }, payload) {
    var ref;
    var id;
    if (rootGetters['app/esNegocio']) {
      id = rootState.app.negocioGest;
      ref = db.collection('negocios').doc(id)
    } else if (rootGetters['app/esDirectorio']) {
      id = rootState.app.directorioGest;
      ref = db.collection('directorios').doc(id)
    }
    return ref.update({
      "web.paginasDinamicas": payload
    })
      .then(() => {
        var promesas = [];
        var storageRef = storage.ref();
        payload.forEach(p => {
          var myblob = new Blob([p.code], {
            type: 'text/javascript'
          });
          var ref = storageRef.child('webPropio/' + id + '/paginasDinamicas/' + p.nombreComponente + '.vue');
          promesas.push(ref.put(myblob))
        })
        return Promise.all(promesas);;
      })
  }
}